//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: 20,
  },
  tableDownInResponsive: {
    marginBottom: 150,
  },
  createBtn: {
    float: "right",
    marginRight: 10,
  },
  link: {
    color: "blue",
    textDecoration: "underline",
    cursor: "pointer",
  },
  promotionDetails: {
    fontSize: 16,
    padding: 10,
    marginBottom: 20,
    borderRadius: 10,
    background: "linear-gradient(0deg, #f0f0f0, #d2d2d2)",
  },
  // Create
  dateInput: {
    width: "100%",
  },
  submitBtn: {
    color: "#fff",
    backgroundColor: "#305698 !important",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    width: 100,
    "&:hover": {
      backgroundColor: "#305698 !important",
    },
  },
  // View
  label: {
    verticalAlign: "-webkit-baseline-middle",
  },
  editInput: {
    width: "80%",
  },
  cancelBtn: {
    color: "#305698",
    backgroundColor: "#fff !important",
    fontSize: 15,
    border: "1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    width: 100,
    "&:hover": {
      backgroundColor: "#fff !important",
    },
  },
  table: {
    minWidth: 750,
  },
  tableHeader: {
    background: "#EDEDED",
    boxShadow:
      "rgb(112 112 112 / 60%) 0px 1.5px 4px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 1px 0px, rgb(255 255 255) 0px -4px 0px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 0px 0px",
  },
  rowCell: {
    fontSize: 15,
    fontFamily: "segoe-ui",
    padding: "5px",
    border: "1px solid grey",
  },
  tableContainer: {},
  tableHeading: {
    color: "#000",
    fontWeight: "bold",
    fontSize: 14,
    fontFamily: "segoe-ui !important",
    padding: 5,
    border: "1px solid",
  },
  backBtn: {
    position: 'absolute', 
    left: 0,
    color: "#fff",
    backgroundColor: "#305698",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 70,
    height: 35,
    textTransform: "capitalize",
    cursor: 'pointer'
  },
  uploadBtn: {
    color: "#fff",
    backgroundColor: "#305698 !important",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    width: 70,
    "&:hover": {
      backgroundColor: "#305698 !important",
    },
  },
  exportBtn: {
    color: "#fff",
    width: "80px",
    height: "35px",
    fontSize: "14px",
    cursor: "pointer",
    fontFamily: "segoe-ui",
    borderRadius: 5,
    backgroundColor: "#2F7CBD",
    border: "none",
    // marginLeft: 16,
    marginTop: -5,
    "@media (max-width: 600px)": {
      marginTop: "4rem",
      
    },
  },
  closeIcon: {
    fontSize: 16,
    position: 'absolute',
    top: 5,
    right: 5,
    cursor: 'pointer'
  },
  popupBtnDiv: {
    height: 60,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  searchInput: {
    width: 350,
    borderRadius: 20,
    
    "@media (max-width: 600px)": {
      width: "100%",
      padding: 10,
    },
  },
  searchInputIcon: {
    cursor: "pointer",
  },

  promotion:{
    float: "left",
    marginRight: 5,
    
  },

 criteriarule:{
    float: "right",
    marginRight: 35,
  },
  
}));
